const Product = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-box"></i>
        <p>Product page</p>
      </div>
    </div>
  );
};

export default Product;
